import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme) => ({
  bulkModalContent: {
    overflowY: "unset",
    height: theme.custom.bulkModalDialogContentHeight,
    overflow: "auto",
    overflowX: "hidden",
    maxHeight: theme.custom.bulkModalDialogContentHeight,
    flexDirection: "column"
  },
  bulkModalContentInfoMessage: {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(2)
  },
  bulkModalContentContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    gap: theme.spacing(2)
  }
}));
const BulkModalContent = ({ subInfoMessage, children, className }) => {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement(Box, { className: cx(classes.bulkModalContent, className) }, subInfoMessage ? /* @__PURE__ */ React.createElement(Box, { className: classes.bulkModalContentInfoMessage }, subInfoMessage) : null, /* @__PURE__ */ React.createElement("div", { className: classes.bulkModalContentContainer }, children));
};
export {
  BulkModalContent
};
//# sourceMappingURL=BulkModalContent.js.map
